<script setup lang="ts">
import { Quote, Star } from "lucide-vue-next";
import "@/assets/styles/review.css";

const reviews = [
  { text: "Freiraum hat nicht nur gebaut, sondern mitgedacht. Termine, Abstimmung und Ausführung waren vom ersten Gespräch bis zur Übergabe vorbildlich.", name: "Mara Hoffmann", role: "Projektleitung, Hagedorn Immobilien" },
  { text: "Unsere Außenanlage ist heute ein Ort, an dem Mitarbeitende wirklich gerne Pause machen. Genau diese Wirkung hatten wir uns gewünscht.", name: "Daniel Roth", role: "Geschäftsführer, Roth & Partner" },
  { text: "Ein starkes Team, das pragmatisch löst und dabei den gestalterischen Anspruch nie verliert. Die Zusammenarbeit war angenehm klar.", name: "Julia Stein", role: "Private Auftraggeberin" }
];
</script>

<template>
  <section class="reviews-section" id="reviews">
    <div class="section-shell">
      <div class="review-heading reveal"><span class="eyebrow">Vertrauen wächst</span><h2>Was bleibt, ist ein<br /><em>gutes Gefühl.</em></h2></div>
      <div class="reviews-grid">
        <article class="review-card reveal" v-for="review in reviews" :key="review.name">
          <div class="review-card-top"><Quote /><div><Star v-for="n in 5" :key="n" /></div></div>
          <p>„{{ review.text }}“</p>
          <footer><strong>{{ review.name }}</strong><span>{{ review.role }}</span></footer>
        </article>
      </div>
    </div>
  </section>
</template>
